module.exports = __webpack_public_path__ + "static/media/overlay7.61dab4c1.png";